import React from 'react';
import Header from '@/components/Header'
import Footer from '@/components/Footer';
import Cookies from "js-cookie";
import api_domain_config from "@/config/config";
import { connect } from "react-redux";
import actions from "@/redux/action";
import { useRoutes } from "react-router-dom";
import routes from '@/router/router';
import './App.less';

const App = (props) => {
  //根据路由表生成对应的路由规则
  const element = useRoutes(routes);

  /**
   * 获取当前地址栏上携带的token(从客户端跳转过来)
   */
   const urlParams = new URL(window.location.href).searchParams;
   let curUserToken = urlParams.get('token');
  if (curUserToken) {
    /**
     * 将当前地址栏上的token解密后，截取掉前12个字符，才是真正的token
     */
    curUserToken = window.atob(curUserToken).slice(0, -12);
    /**
     * 更新当前store中的数据
     */
    props.onAuthorizationChange(curUserToken);
    //将当前authorization存在顶级域名cookies底下
    Cookies.set("authorization", curUserToken, { expires: 30, domain: api_domain_config.DOMAIN });
  }

  //退出登录
  const handleLogout = () => {
    /**
     * 删除当前的用户信息和token
     */
    Cookies.remove("authorization", { domain: api_domain_config.DOMAIN });
    /**
     * 删除当前用户信息
     */
    localStorage.removeItem('currentUserInfo');
    //退出登录跳转首页
    window.location.href = 'https://www.niuxuezhang.cn/';
    // window.location.href = 'http://192.168.61.49:8081/purchase/buy-test.html' 
  }

  return (
    <>
      <Header handleLogout={handleLogout} />
        {element}
      <Footer />
    </>
  );
}

const mapStateToPropos = state => ({
  authorization: state.account.authorization,
});
const mapDispatchToProps = dispatch => ({
  onAuthorizationChange: authorization => dispatch(actions.onAuthorizationChange(authorization)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(App);